<template>
    <div id="help">
        <!--<div class="helpHeader">
            <h2 class="title main-container"><img @click="toIndex" src="../../assets/images/topBar1/logoIcon.png"/>帮助中心</h2>
        </div>-->
        <my-header></my-header>
        <div class="main-container tableWrap">
            <el-table
                :data="tableData"
                tooltip-effect="light"
                @current-change="handleCurrentChange"
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="articleTitle"
                    label="文档名称">
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    label="附件信息">
                    <template slot-scope="scope">
                        <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row.sattachment)" title="点击下载">
                           {{ scope.row.sattachment.attachName }}
                        </a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="updateDate"
                    label="发布日期">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    export default {
        name: 'help',
        data() {
            return {
                tableData: [],
                currentRow: null,//当前选中行
            }
        },
        components: {
            MyHeader
        },
        created(){
            var path = this.$route.name;
            if(path == 'help'){
                this.$root.activeIndex = 'setting';
            }
            this.$root.postHttp('/v1/sArticle/public/getListBy',{
                articleType: 1
            },res => {
                this.tableData = res.data.data || [];
            })
        },
        methods: {
            toIndex() {
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            handleCurrentChange(val) {//处理选中某一行的事件；
                this.currentRow = val;
            },
            fileListHandleDownload(file) {
//                console.log(fileList, '下载')
                if(!file){
                    return;
                }
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";
    #help {
        position: relative;
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .standard {
                background: url('../../assets/images/topBar1/standard2.png') no-repeat 5px center / 16px 16px;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .tableWrap {
           padding-top: 80px;
           .el-table .cell {
                text-align: center;
            }
        }
        & .title {
            text-align: left;
            & img {
                width: 240px;
                height: 29px;
                margin-right: 20px;
                vertical-align: text-bottom;
                cursor: pointer;
            }
        }
        & table thead th {
            text-align: center;
        }
        & .words {
            color: #333;
            text-decoration: none;
        }
        & .words:hover {
            color: $--primary-color;
            text-decoration: underline;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Help.vue